import { useQuery, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiHospitalElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiHospitalElFindParams, unknown>

const fetchHospitalFind = async (params: ApiHospitalElFindParams) => {
  const { data } = await apiClient.v2.apiHospitalElFind(params);
  return checkApiResponse(data);
}

export const v2HospitalListKeys = {
  all: [QUERY_KEY.v2apiHospitalElFind] as const,
  detail: (params: ApiHospitalElFindParams) => [...v2HospitalListKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — 부트스트랩처럼 순차 흐름이 필요한 곳에서
 * `queryClient.fetchQuery(v2HospitalFindQueryOptions(params))` 로 사용한다 (캐시 경유는 동일) */
export const v2HospitalFindQueryOptions = (params: ApiHospitalElFindParams) => ({
  queryKey: v2HospitalListKeys.detail(params),
  queryFn: () => fetchHospitalFind(params),
})

export const useV2HospitalFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2HospitalListKeys.detail(resolveMaybeGetter(params)),
    queryFn: () => fetchHospitalFind(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
